import React, { useState, useRef, useEffect } from "react";
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { useNavigate, useParams, useOutletContext } from "react-router-dom";
import { getReviewsApi } from "../../../api/userApi/userApi";
import useEncryption from '../../../services/useEncryption';
import { toast } from "react-toastify";
import useHeaders from "../../../helpers/useHeaders";
import useToast from "../../../helpers/useToast";
import { createAuditLogs } from "../../../api/providerApi/providerApi";
import { convertToUSFormat } from "../../../helpers/utils";
import { toggleShowReviewApi } from "../../../api/userApi/userApi";

import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';

import { visuallyHidden } from '@mui/utils';
import { useSelector } from "react-redux";
import { selectAuth } from "../../../redux/slice/authSlice";





function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'created_at',
        numeric: true,
        disablePadding: true,
        label: 'Date Submitted',
    },
    {
        id: 'name',
        numeric: true,
        disablePadding: false,
        label: 'Name',
    },
    {
        id: 'rating',
        numeric: true,
        disablePadding: false,
        label: 'Ratings',
    },
    {
        id: 'reviews',
        numeric: true,
        disablePadding: false,
        label: 'Reviews',
    },
    // {
    //     id: 'showReview',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Show Review',
    // },


];

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {/* <TableCell padding="checkbox">
                    
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all reviews',
                        }}
                    />

                </TableCell> */}
                {headCells?.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        // align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell?.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (<></>
       
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};



export const Reviewtable = ({search, update, setUpdate}) => {
    const toastOptions = useToast();
    const { id } = useParams();
    const headers = useHeaders();
    const [order, setOrder] = React.useState("desc");
    const { encryptData, decryptData } = useEncryption();
    const [orderBy, setOrderBy] = React.useState('created_at');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [loading, setLoading] = useOutletContext();
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [rows, setRows] = useState([]);
    const [totalReviews, setTotalReviews] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const decryptedId = decryptData(decodeURIComponent(id));
    const { role } = useSelector(selectAuth);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
          const newSelected = rows.map((row) => row.id);
          setSelected(newSelected);
          return;
        }
        setSelected([]); 
      };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

   
  const emptyRows = rows?.length == 0;
    

useEffect(() => {
  fetchData();
}, [page, rowsPerPage, order, orderBy, search, update]);

const fetchData = async () => {
  try {
    setLoading(true);
    const response = await getReviewsApi(decryptedId, page, rowsPerPage, orderBy, order, search);
    const decryptedData = decryptData(response?.data?.data);
    setRows(decryptedData?.reviews);
    setTotalReviews(decryptedData?.totalReviews);
    setTotalPages(decryptedData?.totalPages);
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.error("Error fetching data:", error);
  }
};

const handleToggleShowReview = async (reviewId ) => {
    
    try {
        let review = rows.find((r) => r.id === reviewId);
        
        if (!review) {
          toast.error('Review not found', toastOptions);
          return;
        }
    
        const newShowReviewStatus = !review.showReview;
    
        const response = await toggleShowReviewApi(reviewId, headers);
    
        toast.success(response?.data?.message, toastOptions);
    
        setUpdate(prev => !prev);
    
        let obj = {
          event: `${role} ${newShowReviewStatus ? 'enabled' : 'disabled'} the review for ${review.name}.`,
        };
    
        await createAuditLogs({ data: encryptData(obj) }, headers);
    
      } catch (error) {
        console.error("Failed to update show review status:", error);
        toast.error(error?.response?.data?.message, toastOptions);
      }
  };

    return (
        <div className='tableDesigned'>
            <Box>
                <Paper>
                    <EnhancedTableToolbar numSelected={selected.length} />
                    <TableContainer>
                        <Table>
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={totalReviews}
                            />
                            <TableBody>
                                {rows?.map((row, index) => {
                                    const isItemSelected = isSelected(row?.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row?.id}
                                            selected={isItemSelected}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            {/* <TableCell padding="checkbox">
                                                <Checkbox
                                                    onClick={(event) => handleClick(event, row?.id)}
                                                    color="primary"
                                                    checked={isItemSelected}
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                    }}
                                                />
                                            </TableCell> */}
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                            >
                                                {convertToUSFormat(row?.created_at)}
                                            </TableCell>
                                            <TableCell>{row?.name}</TableCell>
                                            <TableCell >{row?.rating}</TableCell>
                                            <TableCell >{row?.reviews}</TableCell>
                                          
                                            

                                        </TableRow>
                                    );
                                })}
                                    {emptyRows && (
                                      <TableRow
                                        style={{
                                          height: (dense ? 33 : 53) * emptyRows,
                                        }}
                                      >
                                        <TableCell colSpan={8} className="norecord">
                                          No Record Found
                                        </TableCell>
                                      </TableRow>
                                    )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalReviews}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </Box>
        </div>
    );
}